export const routePaths = {
  root: '/',
  redirectAuth: `/${import.meta.env.VITE_APP_REDIRECT_URI}`,
  signIn: '/sign-in',
  app: '/app',
  organizations: '/app/organizations',
  subscriptions: '/app/organizations/:organizationId/subscriptions',
  properties: '/app/organizations/:organizationId/properties',
  workspaceDashboard: '/app/organizations/workspace/:workspaceId/dashboard',
  view: '/app/organizations/:organizationId/properties/:propertyId',
  viewNotFound: '/app/organizations/:organizationId/properties/:propertyId/*',
  notes: '/app/organizations/:organizationId/properties/:propertyId/notes',
  notesCreate: '/app/organizations/:organizationId/properties/:propertyId/notes/create',
  notesEdit: '/app/organizations/:organizationId/properties/:propertyId/notes/edit/:noteId',
  analytics: '/app/organizations/:organizationId/properties/:propertyId/analytics',
  aiInsights: '/app/organizations/:organizationId/properties/:propertyId/ai-insights',
  prescriptions: '/app/organizations/:organizationId/properties/:propertyId/prescriptions',
  prescriptionsOptions:
    '/app/organizations/:organizationId/properties/:propertyId/prescriptions/options',
  prescriptionsCreate:
    '/app/organizations/:organizationId/properties/:propertyId/prescriptions/create',
  prescriptionsEdit:
    '/app/organizations/:organizationId/properties/:propertyId/prescriptions/edit/:prescriptionId',
  productivityMaps: '/app/organizations/:organizationId/properties/:propertyId/productivity',
  productivityMapsCreate:
    '/app/organizations/:organizationId/properties/:propertyId/productivity/create',
  anomalyComparison:
    '/app/organizations/:organizationId/properties/:propertyId/region/:regionId/field/:fieldId/anomaly-comparison',
  yieldAnalysis: '/app/organizations/:organizationId/properties/:propertyId/yield-analysis',
  yieldAnalysisOverview:
    '/app/organizations/:organizationId/properties/:propertyId/yield-analysis/overview',
  dataLayers: '/app/organizations/:organizationId/properties/:propertyId/data-layers',
  dashboard: '/app/organizations/:organizationId/properties/:propertyId/dashboard',
  modules: '/modules',
  subscriptionsModule: '/modules/subscriptions',
};
